webpackJsonp([3688020674911758000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/photos-gothenburg.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"name": "gothenburg",
			"photos": [
				"gothenburg/DSC_0448.jpg",
				"gothenburg/DSC_0453.jpg",
				"gothenburg/DSC_0454.jpg",
				"gothenburg/DSC_0458.jpg",
				"gothenburg/DSC_0461.jpg",
				"gothenburg/DSC_0463.jpg",
				"gothenburg/DSC_0464.jpg",
				"gothenburg/DSC_0473.jpg",
				"gothenburg/DSC_0481.jpg",
				"gothenburg/DSC_0484.jpg",
				"gothenburg/DSC_0485.jpg",
				"gothenburg/DSC_0486.jpg",
				"gothenburg/DSC_0487.jpg"
			],
			"next": {
				"name": "munich"
			},
			"previous": {
				"name": "oslo"
			}
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---photos-gothenburg-3c00bd8f26f286389eaa.js